/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The environment of the application
 */
export const Environment = {
  Sandbox: "sandbox",
  Janeway: "janeway",
  Office: "office",
  Production: "production",
} as const;
/**
 * The environment of the application
 */
export type Environment = OpenEnum<typeof Environment>;

/**
 * Information about the environment that the software is deployed to
 */
export type DeploymentConfig = {
  /**
   * Base URL of this environment's Enterprise Control Platform API
   */
  ecpApiUrl: string;
  /**
   * The environment of the application
   */
  environment: Environment;
  /**
   * Whether this is a production environment
   */
  isProduction: boolean;
};

/** @internal */
export const Environment$inboundSchema: z.ZodType<
  Environment,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(Environment);

/** @internal */
export const DeploymentConfig$inboundSchema: z.ZodType<
  DeploymentConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  ecp_api_url: types.string(),
  environment: Environment$inboundSchema,
  is_production: types.boolean(),
}).transform((v) => {
  return remap$(v, {
    "ecp_api_url": "ecpApiUrl",
    "is_production": "isProduction",
  });
});

export function deploymentConfigFromJSON(
  jsonString: string,
): SafeParseResult<DeploymentConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeploymentConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeploymentConfig' from JSON`,
  );
}
